import { TchekImage } from './../model/image';
import { ImagesService } from './../service/images.service';
import { settings } from 'cluster';
import { Component, OnInit, DoCheck, OnDestroy } from '@angular/core';
import { ReportService } from '../service/report.service';
import { ActivatedRoute } from '@angular/router';
import { Report } from '../model/report.model';
import * as $ from 'jquery';
import { Location } from '@angular/common';
import { Settings } from '../model/settings.model';
import { ParametersService } from '../service/parameters.service';
import { Subject, Subscription } from 'rxjs';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.less']
})
export class ReportComponent implements OnInit {
  currentSection = 'report-analysis';
  report: Report;
  settings: Settings;
  showSignatory: boolean = true;
  showVehicleDetails: boolean = true;
  showPreselection: boolean = true;
  currentImage: TchekImage;

  constructor(
    private readonly _reportService: ReportService,
    private readonly _route: ActivatedRoute,
    readonly _locationService: Location,
    private readonly _parametersService: ParametersService,
  ) {

    this.settings = this._parametersService.getAll();
    this._route.paramMap.subscribe((params) => {
      this._reportService.get(params.get('id')).then(report => {
        console.log("report get after save id ", report);
        this.report = report;
        this.filters()
      });
    });
  }

  updateClass(newClass: string) {
    this.settings.vehicle.classes[0].value = newClass
  }

  filters() {
    if (this.report) {
      if (this.report.typeReport === 'simple') {
        this.showSignatory = this.settings.report.simple.signatory;
      } else {
        this.showSignatory = this.settings.report.state.signatory;
      }
      if (this.showSignatory === undefined)
        this.showSignatory = true;
    }
    if (this.report.typeReport === 'simple') {
      this.showVehicleDetails = this.settings.report.simple.vehicleDetails;
    } else {
      this.showVehicleDetails = this.settings.report.state.vehicleDetails;
    }
    if (this.showVehicleDetails === undefined)
      this.showVehicleDetails = true;

    if (this.report.typeReport === 'simple'
      && this.settings
      && this.settings.report
      && this.settings.report.simple
      && this.settings.report.simple.picturesPreSelected !== undefined)
      this.showPreselection = this.settings.report.simple.picturesPreSelected;
    else if (this.settings
      && this.settings.report
      && this.settings.report.state
      && this.settings.report.state.picturesPreSelected !== undefined)
      this.showPreselection = this.settings.report.state.picturesPreSelected;
    else
      this.showPreselection = true;
  }

  ngOnInit() {
    $(window).on('scroll', () => {
      if ($(window).scrollTop() > 154) {
        $('#report-header').removeClass('hide-out');
        $('#report-header').addClass('show-in');
        $('#report-sub').addClass('invisible');
      } else if ($('#report-header').hasClass('show-in')) {
        $('#report-header').addClass('hide-out');
        $('#report-header').removeClass('show-in');
        $('#report-sub').removeClass('invisible');
      }
    });
  }


  onSectionChange(sectionId: string) {
    this.currentSection = sectionId;
  }

  topNavHeight(): number {
    return $('.top-nav').height();
  }
}



// WEBPACK FOOTER //
// ./src/app/report/report.component.ts